import { classNames } from "./utils.js";
import { useBoxes, useOccupancies } from "./hooks/context.js";
import React, { useCallback, useMemo } from "react";
import { layout } from "./layout.js";
import { stylesheet } from "typestyle";
import { ListItem } from "./list.js";
export function BoxNumberSelection({ onSelect, className }) {
    const boxes = useBoxes();
    const occupancies = useOccupancies();
    const availableBoxes = useMemo(() => {
        const occupied = occupancies.map(o => o.boxNumber);
        return boxes
            .filter(b => !b.maintenanceRequiredAt && !occupied.includes(b.number));
    }, [occupancies, boxes]);
    return (React.createElement("div", { className: classNames(layout.vertical, styles.container, layout.fill, className) },
        React.createElement("div", { className: classNames(layout.horizontalWrap, layout.fill, styles.boxSelection), style: { background: 'inherit' } },
            availableBoxes.map(b => (React.createElement(BoxNumberItem, { key: b.number, box: b, onSelect: onSelect }))),
            React.createElement("div", { style: { flexGrow: 1 } }))));
}
function BoxNumberItem({ box, onSelect }) {
    const handleClick = useCallback(() => onSelect(box.number), []);
    return (React.createElement("div", { className: styles.boxItem },
        React.createElement(ListItem, { onClick: handleClick },
            React.createElement("div", { className: styles.boxNumber }, box.number),
            box.types.map(type => React.createElement("div", { key: type, className: styles.boxType }, type)))));
}
const styles = stylesheet({
    container: {
        background: "var(--color-background-less-contrast)",
        alignItems: 'center',
    },
    boxSelection: {
        width: 'max-content',
        maxWidth: '100%',
        maxHeight: '100%',
        overflow: 'auto',
        padding: "0.75em",
        flexDirection: 'column',
        justifyContent: "flex-start",
    },
    boxItem: {
        padding: "0.75em",
        minWidth: '10em',
        maxWidth: '10em',
        cursor: 'pointer'
    },
    boxNumber: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '0.5em',
        fontSize: '1.2rem',
        width: '3rem',
        height: '3rem',
        borderRadius: '2rem',
        backgroundColor: 'var(--color-background-less-contrast)',
    },
    boxType: {
        fontSize: '1.6rem',
        marginLeft: '0.5em',
    }
});
//# sourceMappingURL=BoxNumberSelection.js.map